import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon-as-button" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tooltip, {
      text: $props.tooltip || '',
      teleported: $props.teleported
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Icon, {
          stroke: $options.c_stroke,
          width: $props.size,
          height: $props.size,
          icon: $props.icon,
          style: {"cursor":"pointer"},
          "stroke-width": $props.strokeWidth,
          hoverable: ""
        }, null, 8 /* PROPS */, ["stroke", "width", "height", "icon", "stroke-width"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["text", "teleported"])
  ]))
}